module.exports = __webpack_public_path__ + "static/img/recom.92a390f9.png";